import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './Tooltip.scss';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

interface BubblePosition {
  top: number;
  left: number;
}

const Tooltip = ({ content, children }: TooltipProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [position, setPosition] = useState<BubblePosition | null>(null);

  const handleMouseEnter = () => {
    if (!wrapperRef.current) {
      return;
    }

    const rect: DOMRect = wrapperRef.current.getBoundingClientRect();

    setPosition({
      top: rect.top - 10,
      left: rect.left,
    });
  };

  const handleMouseLeave = () => {
    setPosition(null);
  };

  return (
    <div
      ref={wrapperRef}
      className="tooltip__wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {position
        && createPortal(
          <div
            className="tooltip__bubble"
            style={{ top: position.top, left: position.left }}
          >
            {content}
            <span className="tooltip__arrow" />
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Tooltip;